import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-industry-section',
  templateUrl: './industry-section.component.html',
  styleUrls: ['./industry-section.component.css']
})
export class IndustrySectionComponent implements OnInit {

  clickValueItem(event){
    if(event.target.closest(".value")){
      let coreValueItemsContainer = event.target.closest(".by-industry-items");
      let valueItem = event.target.closest(".value");

      let visibleItem = coreValueItemsContainer.querySelector(".visible-value-pop-up");

      if(visibleItem && valueItem!==visibleItem){
        visibleItem.classList.remove("visible-value-pop-up"); 
        visibleItem.classList.remove("active-item");      
      }  

        valueItem.classList.toggle("visible-value-pop-up");
        valueItem.classList.toggle("active-item");

    }
  }

  constructor(private route: ActivatedRoute) {
    this.route.fragment.subscribe((fragment) => {
      if(fragment) {
          setTimeout(()=>{
              document.getElementById(fragment)?.scrollIntoView({behavior: "smooth", block: "center" , inline: "nearest"});
          }, 500)
      }
    });
   }

  ngOnInit(): void {
  }

}
